function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M13 25.639A8.804 8.804 0 0 0 17.718 27c5.66 0 8.756-4.617 8.756-8.62 0-.132-.003-.261-.01-.391A6.188 6.188 0 0 0 28 16.42a6.16 6.16 0 0 1-1.767.476 3.046 3.046 0 0 0 1.353-1.675 6.24 6.24 0 0 1-1.954.735A3.098 3.098 0 0 0 23.384 15c-1.7 0-3.078 1.355-3.078 3.028 0 .238.028.469.08.69a8.778 8.778 0 0 1-6.342-3.165 2.983 2.983 0 0 0-.417 1.524c0 1.05.543 1.978 1.368 2.521a3.081 3.081 0 0 1-1.394-.378v.038c0 1.467 1.062 2.692 2.468 2.97-.453.122-.928.14-1.389.052a3.07 3.07 0 0 0 2.874 2.104 6.228 6.228 0 0 1-3.82 1.296 6.1 6.1 0 0 1-.735-.041"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Twitter.0ec5a6df.svg";
export { ForwardRef as ReactComponent };